<template>
  <div>
    <div style="background-color: #fff;padding: 10px 10px 0px 10px; margin-bottom: 20px;" v-if="routeQueryType !== 'offer'">
      
    
    <el-tabs v-model="currentIndex" type="card" @tab-click="handleTab" >
        <el-tab-pane
          v-for="(item, index) of tabArr"
          :key="index"
          :label="item.tabName"
          :name="`${index}`"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="currentIndex == '0'">
      <baseInfo :routeData="routeData"></baseInfo>
      <inquirySkuList
        v-if="tableData.length"
        :routeData="routeData"
        @change="changeTableData"
        :tableData="tableData"
        :consultationType="consultationType"
        :routeQueryType="routeQueryType"
        :isShowConsultRecord="isShowConsultRecord"
      ></inquirySkuList>
      <otherInfo
        :isUploadBtn="isUploadBtn"
        :routeQueryType="routeQueryType"
        :routeData="routeData"
        ref="otherInfo"
        :supplierOfferAttachmentListShow="supplierOfferAttachmentListShow"
      ></otherInfo>
    </div>
    <div v-if="currentIndex == '1'">
         <enquiryResult></enquiryResult>
    </div>
    <!-- 底部按钮 -->
    <div class="btn-bottom">
      <eui-btn type="secondary" @click="toBack(null)">
        <eui-icon icon="eicon-arrow-left"></eui-icon>
        返回</eui-btn
      >
      <eui-btn
        v-if="routeQueryType == 'offer' && !consultationType"
        v-debounce="handleSubmit"
        :disabled="btnLoading"
        type="primary"
        style="margin-left: 30px"
      >
        报价
      </eui-btn>
      <div v-if="routeQueryType == 'offer' && consultationType === 1">
        <eui-btn
          @click="openRejectDialog"
          :disabled="btnLoading"
          type="primary"
          style="margin-left: 30px"
        >
          拒绝
        </eui-btn>
        <eui-btn
          v-debounce="okHandle"
          :disabled="btnLoading"
          type="primary"
          style="margin-left: 30px"
        >
          确认报价
        </eui-btn>
      </div>
    </div>
    <e-dialog
      dialog-title="提示"
      :dialog-type="''"
      :center-dialog-visible="blackVisible"
      :popup-width="'450px'"
      :show-close="false"
      @updateVisible="handleBlackClose"
      @resetPopupData="handleBlackClose"
      @submitPopupData="handleBlackClose"
    >
      <div>
        {{
          `您已被限制对该企业报价，请联系采购管家${blackInfo.purchaseButlerMobile}。`
        }}
      </div>
    </e-dialog>
    <e-dialog
      v-if="rejectVisible"
      dialogTitle="请填写拒绝原因"
      :centerDialogVisible="rejectVisible"
      @resetPopupData="rejectVisible = false"
      @submitPopupData="handleReject"
      :popupWidth="'500px'"
    >
      <el-form :model="rejectObj" label-width="100px">
        <el-form-item label="拒绝原因:">
          <el-input
            type="textarea"
            :row="3"
            maxlength="300"
            show-word-limit
            v-model="rejectObj.refuseReason"
          ></el-input>
        </el-form-item>
      </el-form>
    </e-dialog>
  </div>
</template>

<script>
import baseInfo from './components/baseInfo.vue';
import api from '@/modules/projectA/api/order';
import Api from '@/modules/projectA/api/enquiry';
import moment from 'moment';
import inquirySkuList from './components/inquirySkuList.vue';
import otherInfo from './components/otherInfo.vue';
import apiLogin from '@/modules/projectA/api/login/index';
import eDialog from '@/components/common/e-dialog.vue';
import { callBackUrl } from '@/modules/projectA/api/config';
import enquiryResult from './components/enquiryResult.vue';
export default {
  components: {
    baseInfo,
    inquirySkuList,
    otherInfo,
    eDialog,
    enquiryResult,
  },
  data() {
    return {
      tabArr:[
        {
          tabName:'基础信息',
          
        },
        {
          tabName:'询价结果',
        }
      ],
      currentIndex:0,
      btnLoading: false,
      blackVisible: false,
      rejectVisible: false,
      rejectObj: {
        refuseReason: '',
      },
      blackInfo: {},

      routeData: {},
      routeQueryType: '',
      enquiryId: '',
      consultationType: 0,
      isShowConsultRecord: 0,
      loading: false,
      isUploadBtn: false,
      supplierOfferAttachmentListShow: [],
      tableData: [],
      form: {
        quotationValidity: moment()
          .add('days', 90)
          .format('YYYY-MM-DD HH:mm:ss'),
      },
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    },
  },
  created() {
    const {
      isShowConsultRecord = 0,
      consultationType = 0,
      type,
      enquiryId,
    } = this.$route.query;
    this.consultationType = Number(consultationType);
    console.log('isShowConsultRecord:', isShowConsultRecord);

    this.isShowConsultRecord = Number(isShowConsultRecord);
    this.routeQueryType = type || 'offer';
    this.enquiryId = enquiryId;

    this.setTitle();
    if (this.routeQueryType === 'offer') {
      if (consultationType === 0) { //第一次报价请求的接口
        //询价单详情
        this.queryEnquiryDetailByEnquiryId();
      } else { // 磋商之后 报价和确认报价请求的接口
        // 供应商填写报价, 确认报价跳转调这个接口
        this.queryEnquiryDetailAndConsultByEnquiryId();
      }
      this.isUploadBtn = true;
    } else { //查看详情的接口
      this.querySupplierOfferDetailList();
      this.isUploadBtn = false;
    }
  },
  methods: {
    handleTab(tab, event) {
      console.log(tab, event);
    },
    openRejectDialog() {
      this.rejectVisible = true;
    },
    changeTableData(data) {
      console.log('data:', data);
      this.tableData = data;
    },
    async getConsultationWaitConfirm(confirmStatus, refuseReason) {
      try {
        const { purchaseCompanyId } = this.routeData;
        const {
          supplierOfferId,
          enquiryId,
          offerStatus = '',
        } = this.$route.query;
        /* // 确认状态  1：通过 2：拒绝"
          confirmStatus: 2,
          refuseReason: this.rejectObj.refuseReason, */
        const params = {
          enquiryId,
          supplierOfferId,
          purchaseCompanyId,
          confirmStatus,
        };
        this.$refs.otherInfo
          .submitForm()
          .then(async (res) => {
            const {
              valid,
              form,
              supplierOfferAttachmentAOList,
              offerAttachmentCount,
            } = res;
            if (valid) {
              // 通过
              if (confirmStatus === 1) {
                const supplierOfferDetailList = [];
                console.log(this.tableData, 'this.tableData');
                this.tableData.forEach((item) => {
                  const obj = {};
                  const arr = [
                    {
                      attachmentName: null,
                      attachmentRemark: null,
                      attachmentUrl: null,
                    },
                  ];
                  // obj.offerStatus = offerStatus;
                  obj.deliveryDate = item.deliveryDate;
                  obj.remark = item.offerRemark;
                  obj.deliveryFee = item.deliveryFee || 0;
                  obj.enquiryDetailId = item.enquiryDetailId;
                  obj.offerStatus = item.offerStatus || 0;
                  obj.price = item.supplierOfferDetailConsult.price || '';
                  (obj.quantity = item.requiredQuantity),
                    (obj.totalPrice =
                      item.supplierOfferDetailConsult.totalPrice),
                    (obj.supplierOfferDetailAttachmentList =
                      item.enquiryDetailNoteList || arr);

                  supplierOfferDetailList.push({
                    ...item,
                    ...obj,
                  });
                });
                const supplierOfferConsultAo = {
                  supplierOfferDetailList,
                  supplierOfferId,
                  offerMobile: form.offerMobile,
                  offerRealName: form.offerRealName,
                  offerEmail: form.offerEmail,
                  enquiryId: this.enquiryId,
                  haveQuotation: 0,
                  includeFreight: 0,
                  includeTax:0,
                  // 新加参数
                  offerRemark: form.offerRemark || '',
                  offerAttachmentCount: offerAttachmentCount || 0,
                  supplierOfferAttachmentAOList:
                    supplierOfferAttachmentAOList || [],
                  externalUrl: `${callBackUrl}/huadongSeeDetails?enquiryId=${this.enquiryId}&type=viewDetails&supplierOfferId=`,
                };
                params.supplierOfferConsultAo = supplierOfferConsultAo;
              } else {
                params.refuseReason = refuseReason;
              }

              console.log(params, '参数');
              const res = await Api.consultationWaitConfirm(params);
              if (res.code === '200') {
                this.$message.success('操作成功');
                this.rejectVisible = false;
                this.rejectObj.refuseReason = '';
                this.$router.back();
              }
            }
          })
          .catch((err) => {
            console.log(err, 'err');
          });
      } catch (err) {
        console.log(err);
      }
    },
    //拒绝
    async handleReject() {
      if (!this.rejectObj.refuseReason) {
        this.$message.error('请输入拒绝原因');
        return;
      }
      this.getConsultationWaitConfirm(2, this.rejectObj.refuseReason);
    },
    okHandle() {
      this.getConsultationWaitConfirm(1);
    },

    // 提交报价
    async handleSubmit() {
      // 单价校验
      if (!this.tableData.every((item) => item.price)) {
        return this.$message.warning('请填写报价单价');
      }
      // 填写报价单价
      if (this.tableData.some((item) => item.price == '0.00')) {
        return this.$message.warning('请填写报价单价');
      }
      // 单价校验
      if (!this.tableData.every((item) => item.deliveryDate)) {
        return this.$message.warning('请填写交货期');
      }

      const { purchaseCompanyId } = this.routeData;
      const result = await api.blackCheck({
        inquiryCompanyId: purchaseCompanyId,
        companyId: this.$store.state.USERINFO.companyId,
      });

      // 限额
      /* if (this.routeData.quotationLimit) {
        if(this.allPrice > this.routeData.quotationLimit) {
          this.$message.warning('报价总额不可超过报价限额，请修改。')
          return
        }
      } */

      if (result.code === '200') {
        if (result.data.existFlag) {
          // 弹窗提示
          this.blackVisible = true;
          this.blackInfo = { ...result.data };
        } else {
          console.log(this.$refs.form, 'this.$refs.form');

          this.$refs.otherInfo
            .submitForm()
            .then((res) => {
              const {
                valid,
                form,
                supplierOfferAttachmentAOList,
                offerAttachmentCount,
              } = res;

              if (valid) {
                const { offerStatus = '', supplierOfferId,createSource } = this.$route.query;
                const supplierOfferDetailList = [];
                this.tableData.forEach((item) => {
                  const obj = {};
                  const arr = [
                    {
                      attachmentName: null,
                      attachmentRemark: null,
                      attachmentUrl: null,
                    },
                  ];
                  // obj.offerStatus = offerStatus;
                  obj.deliveryDate = item.deliveryDate;
                  obj.remark = item.offerRemark;
                  obj.deliveryFee = item.deliveryFee || 0;
                  obj.enquiryDetailId = item.enquiryDetailId;
                  obj.offerStatus = item.offerStatus || 0;
                  obj.price = item.price || '';
                  (obj.quantity = item.requiredQuantity),
                    (obj.totalPrice = item.totalPrice),
                    (obj.supplierOfferDetailAttachmentList =
                      item.enquiryDetailNoteList || arr);
                  // obj.taxCode = item.taxRate?.taxRateCode || '';
                  // obj.taxRate =
                  //   (item.taxRate &&
                  //     item.taxRate.taxRate.slice(
                  //       0,
                  //       item.taxRate.taxRate.length - 1
                  //     )) ||
                  //   '';
                  supplierOfferDetailList.push({
                    ...item,
                    ...obj
                  });
                });

                const params = {
                  createSource,
                  supplierOfferId,
                  offerMobile: form.offerMobile,
                  offerRealName: form.offerRealName,
                  offerEmail: form.offerEmail,

                  enquiryId: this.enquiryId,
                  haveQuotation: 0,
                  includeFreight: 0,
                  includeTax:0,
                  supplierOfferDetailList,
                  // 新加参数
                  offerRemark: form.offerRemark || '',
                  offerAttachmentCount: offerAttachmentCount || 0,
                  supplierOfferAttachmentAOList:
                    supplierOfferAttachmentAOList || [],
                  externalUrl: `${callBackUrl}/huadongSeeDetails?enquiryId=${this.enquiryId}&type=viewDetails&supplierOfferId=`,
                };
                console.log('提交参数：', params);
                if (offerStatus === '6') {
                  this.supplierOfferConsult(params);
                  return;
                }
                this.addSupplierOffer(params);
              } else {
                console.log('error submit!!');
                return false;
              }
            })
            .catch((err) => {
              console.log(err, 'err');
            });
        }
      }
    },
    // 磋商报价
    async supplierOfferConsult(params) {
      try {
        this.btnLoading = true;
        const res = await api.supplierOfferConsult(params);
        if (res.code == '200') {
          this.$message.success('提交成功');
          // this.fileList = [];
          // this.offerNoteForm.note = '';
          // this.offerNoteForm.fileUrl = '';
          // this.offerNoteForm.fileName = '';
          this.submitFlag = false;
          setTimeout(() => {
            let times = new Date();
            times = times.getTime();
            this.toBack(times);
          }, 1000);
        }
      } finally {
        this.btnLoading = false;
      }
    },
    async addSupplierOffer(params) {
      try {
        this.btnLoading = true;
        const res = await api.addSupplierOffer(params);
        if (res.code == '200') {
          this.$message.success('提交成功');
          // this.fileList = [];
          // this.offerNoteForm.note = '';
          // this.offerNoteForm.fileUrl = '';
          // this.offerNoteForm.fileName = '';
          this.submitFlag = false;
          setTimeout(() => {
            let times = new Date();
            times = times.getTime();
            this.toBack(times);
          }, 1000);
        }
      } finally {
        this.btnLoading = false;
      }
    },
    toBack(times) {
      const { back, type } = this.$route.query;
      if (type) {
        if (times !== null) {
          this.$router.push({ path: back, query: { t: times } });
        } else {
          this.$router.push({ path: back });
        }
      } else {
        let times = new Date();
        times = times.getTime();
        this.$router.push({ path: '/openInquiry', query: { t: times } });
      }

      // this.$router.push({ path: '/orderManage' });
    },
    setTitle() {
      this.$store.state.tagsList.map((item) => {
        if (item.path === this.$route.fullPath) {
          const title =
            this.routeQueryType == 'offer'
              ? '华东询比价报价'
              : '华东询比价详情';
          this.$set(item, 'title', title);
        }
      });
    },
    async queryEnquiryDetailByEnquiryId() {
      console.log('查询询价单详情');
      const { enquiryId, supplierOfferId } = this.$route.query;
      const result = await Api.checkEnquiryPower({
        enquiryId,
        supplierOfferId,
        checkType: 3,
      });
      if (result.code === '200') {
        if (!result.data) {
          this.$message.warning('暂无权限查看此信息。');
          this.toBack(null);
          return;
        }
      }
      const params = {
        enquiryId,
        isSupplierVisible: 1,
      };
      const res = await api.queryEnquiryDetailByEnquiryId(params);
      if (res.code === '200') {
        this.routeData = { ...res.data };
        if (res.data.supplierOfferAttachmentList?.length) {
          const supplierOfferAttachmentListShow =
            res.data.supplierOfferAttachmentList;
          this.supplierOfferAttachmentListShow =
            supplierOfferAttachmentListShow.map((item) => ({
              fileUrl: item.attachmentUrl,
              fileName: item.attachmentName,
            }));
        }
        this.tableData = res.data.enquiryDetailList;
        console.log('this.tableData:', this.tableData);
      }
    },
    // 供应商填写报价
    async queryEnquiryDetailAndConsultByEnquiryId() {
      try {
        const params = {
          enquiryId: this.$route.query.enquiryId,
          isSupplierVisible: 1,
          supplierOfferId: this.$route.query.supplierOfferId,
        };
        const res = await Api.queryEnquiryDetailAndConsultByEnquiryId(params);
        if (res.code === '200') {
          console.log(res, 'res飒飒飒撒所是是是');
          this.routeData = { ...res.data };

          // 供应商展示文件
          if (res.data.supplierOfferAttachmentList?.length) {
            const supplierOfferAttachmentListShow =
              res.data.supplierOfferAttachmentList;
            this.supplierOfferAttachmentListShow =
              supplierOfferAttachmentListShow.map((item) => ({
                fileUrl: item.attachmentUrl,
                fileName: item.attachmentName,
              }));
          }
          this.tableData = res.data.supplierOfferDetailList;
          console.log(this.tableData, '接口this.tableData2222');
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 查询报价单详情
    async querySupplierOfferDetailList() {
      const result = await Api.checkEnquiryPower({
        supplierOfferId: this.$route.query.supplierOfferId,
        enquiryId: this.$route.query.enquiryId,
        checkType: 2,
      });
      if (result.code === '200') {
        if (!result.data) {
          this.$message.warning('暂无权限查看此信息。');
          this.toBack(null);
          return;
        }
      }

      const params = {
        supplierOfferId: this.$route.query.supplierOfferId,
      };
      const res = await api.querySupplierOfferDetailList(params);

      if (res.code === '200') {
        console.log('querySupplierOfferDetailList:', res);
        // this.getRateNum(res.data);
        this.routeData = { ...res.data };
        // mall_userInfo
        console.log(
          this.mall_userInfo.companyId,
          res.data.supplierCompanyId,
          'res.data.supplierCompanyId'
        );
        this.isShowProductInfo =
          this.mall_userInfo.companyId === res.data.supplierCompanyId;
        // 展示转换
        if (res.data.enquiryAttachmentList?.length) {
          const enquiryAttachmentUrlShow = res.data.enquiryAttachmentList;
          this.enquiryAttachmentUrlShow = enquiryAttachmentUrlShow.map(
            (item) => ({
              fileUrl: item.attachmentUrl,
              fileName: item.attachmentName,
            })
          );
        }
        // 供应商展示文件
        if (res.data.supplierOfferAttachmentList?.length) {
          const supplierOfferAttachmentListShow =
            res.data.supplierOfferAttachmentList;
          this.supplierOfferAttachmentListShow =
            supplierOfferAttachmentListShow.map((item) => ({
              fileUrl: item.attachmentUrl,
              fileName: item.attachmentName,
            }));
        }
        this.tableData = res.data.supplierOfferDetailList;
        console.log(
          'supplierOfferDetailList:',
          res.data.supplierOfferDetailList
        );
        console.log('tableData0:', this.tableData);
        if (this.tableData.length) {
          this.tableData.forEach((item) => {
            console.log(item, 'item1');
            const taxRate = this.taxList.find((tax) => {
              console.log(tax, 'tax');
              return tax.taxRate === `${item.taxRate}%`;
            });
            this.$set(item, 'taxRate', taxRate);
          });
          // 之前没判断 defaultTax 的情况 所以会报错
          /* if (defaultTax) {
            this.tableData.forEach((item) =>
              this.$set(item, 'taxRate', defaultTax)
            );
          } */
        }
      }
    },
    //心跳延长登录时间
    async getLoginActive() {
      clearInterval(this.getLoginRear);
      clearTimeout(this.getLoginFront);
      this.refreshRear();
      this.refreshFront();
    },

    async refreshRear() {
      this.getLoginFront = setInterval(async () => {
        console.log(new Date().getTime());
        await apiLogin.getLoginInfo();
      }, 600000);
    },

    async refreshFront() {
      let token = this.$cookies.get('epecToken');
      if (token) {
        let epecTokenExpiredTime = this.$cookies.get('epecTokenExpiredTime');
        let now = new Date().getTime();
        let time = epecTokenExpiredTime;
        let timeOut = null;
        if (time > now) {
          let interval = time - now;
          console.log(interval);
          timeOut = interval - 30000;
        }
        console.log(time);
        console.log(timeOut);
        this.getLoginFront = setTimeout(async () => {
          console.log('更新token', new Date().getTime());
          await apiLogin.getLoginInfo().then((res) => {
            this.refreshFront();
          });
        }, timeOut);
      }
    },
    handleBlackClose() {
      this.blackVisible = false;
    },
  },
  beforeDestroy() {
    clearInterval(this.getLoginRear);
    clearTimeout(this.getLoginFront);
  },
};
</script>

<style lang="scss" scoped>
.btn-bottom {
  display: flex;
  justify-content: space-between;
  width: 100%;
  .cancel {
    &:hover,
    :active {
      border: 1px solid #2587ff;
      color: #2587ff;
      background: #f5f5f5;
    }
  }
}
</style>
